import React from 'react';

import authBackground from '../../../assets/images/auth_background.png';
import logo from '../../../assets/images/logo.png';
import { IsMobile } from '../../../helpers/IsMobile';

import styles from './AuthLayout.module.scss';

const AuthLayout = ({ children }) => {
  const isMobile = IsMobile();

  return (
    <div className={styles.root}>
      <div className={styles.backgroundGradient} />
      <div className={isMobile ? styles.imageBackgroundMobile : styles.imageBackground}>
        <img src={authBackground} alt="Background" className={styles.backgroundImage} />
      </div>
      <div className={styles.contentWrapper}>
        <div className={isMobile ? styles.logoMobile : styles.logoWeb}>
          <img src={logo} alt="Logo" className={styles.logoImage} />
        </div>
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
